import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Button, Row, Col } from 'reactstrap';
import { isMobileOnly } from 'react-device-detect';
import useModal from '../../../sharedComponents/useModal/useModal';
import { Theme } from '../../../config/constants';
import { toast } from 'react-toastify';
import reportingApi from '../../../api/reportingApi';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../reducers/ModalsReducer/ModalsActions';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';

const SaveAsCopyModal = ({id, ...props}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { modalProps, headerProps } = useModal(id, {header: {color: 'black', background: 'white'}});
    const { reportTypeId, selectedProducts, selectedOperators, selectedChildren, selectedCategories, selectedSegments, selectedDates, parentPage } = props;
    const [ reportName, setReportName ] = useState('');

    const handleSaveAsCopy = () => {
        if (!reportName) {
            toast.error('Please enter a report name');
            return;
        }
        const params = {
                name: reportName,
                reportTypeId: reportTypeId,
                filters: {
                    dateRange: [
                        ...selectedDates
                    ],
                    categories: [
                        ...selectedCategories
                    ],
                    parentGroups: [
                        ...selectedOperators
                    ],
                    products: [
                        ...selectedProducts
                    ],
                    marketSegments: [
                        ...selectedSegments
                    ],
                    children: [
                        ...(selectedChildren || [])
                    ]
                },
                favourite: false
        };
        reportingApi.createReport.post(params).then((reponse) => {
            toast.success('Report saved successfully');
            setReportName('');
            dispatch(hideModal(id));
            const copiedReport = reponse.data.filter((report) => report.name === params.name).pop();
            queryClient.invalidateQueries((['reportsList', 'reportContent']));
            queryClient.removeQueries({ queryKey: ['reportsList'] });
            navigate(`/${parentPage}/details/${copiedReport.id}`);
        }).catch(err => {
            toast.error(err.data.message || 'Something went wrong saving the report. Try again later.');
            console.error(err);
        });
    };

    return (
        <Modal  {...modalProps}>
            <ModalHeader {...headerProps}>Save Copy of Report</ModalHeader>
            <ModalBody >
                <Form onSubmit={(e) => {e.preventDefault(); handleSaveAsCopy();}} className= {(isMobileOnly ? 'px-2 text-size-16' : 'px-5 text-size-16')} >
                    <FormGroup >
                        <Label className='label-text-header mb-2'>New Report Name</Label>
                        <input
                            type='text'
                            className='form-control'
                            placeholder='Enter new report name'
                            onChange={(e) => setReportName(e.target.value)}
                            value={reportName}
                        />
                    </FormGroup>
                    <Row className='py-2 w-fc mx-auto'>
                        <Col>
                            <Button onClick={() => {handleSaveAsCopy()}} block color={Theme().colors.accentName} className='py-2 px-5 button-label'>Save Copy of Report</Button>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
};

export default SaveAsCopyModal;